export default "__VITE_ASSET__CHcZLk_$__";